<template>
    <v-container fluid>
        <v-row class="pl-4 pr-4">
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <div
                            class="read-only-caption"
                            :alvqa="alvqa + '-caption-address-row'"
                        >{{ $t('lang_GENERIC_AZ_CAPTION_ADDRESS') }}:
                        <BaseIcon   
                            :alvqa="alvqa + '-icon-address-copy-to-clipboard'"
                            :small="true"
                            icon="content_copy" 
                            color="buttonStandard"
                            @click.stop="copyToClipboard($alvPlugin.getAddressInternational(item))"
                        />
                        </div>
                        <span :alvqa="alvqa + '-address'" 
                            v-html="$alvPlugin.getAddressInternational(item)">
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                    <!-- ALVID -->
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-alvid'"
                            >{{ $t('lang_GENERIC_CAPTION_ALVID') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-alvid'"
                            >{{ item.alvId }}</div>
                        </span>
                    <!-- Currency -->
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-currency'"
                            >{{ $t('lang_GENERIC_CAPTION_CURRENCY') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-currency'"
                            >{{ item.currency }}</div>
                        </span>
                    <!-- Membership id -->
                        <span v-if="item.membershipId !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-membership-id'"
                            >{{ $t('lang_AZ_SOCIETY_MEMBERSHIP_ID') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-membership-id'"
                            >{{ item.membershipId }}</div>
                        </span>
                    <!-- Visibility -->
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-visibility'"
                            >{{ $t('lang_AZ_PERSONS_CAPTION_VISIBILITY') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-visibility'"
                            >{{ getVisibility }}</div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col v-if="item.notes !== null && item.notes !== '' && item.notes !== undefined">
                <v-card elevation="0">
                    <v-card-text>
                    <!-- Notes -->
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-notes'"
                            >{{ $t('lang_GENERAL_CAPTION_NOTES') }}:</div>
                            <div :alvqa="alvqa + '-notes'"
                                    v-html="item.notes"
                            ></div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!-- <v-row class="pl-4 pr-4 pt-4 headline">
            <v-col>
                <v-row>
                    <BaseReadOnlyTextField
                        :innerValue="getVisibility"
                        :label="$t('lang_AZ_PERSONS_CAPTION_VISIBILITY')"
                        :alvqa="alvqa + '-textfield-visibility'"
                    />
                </v-row>
            </v-col>
        </v-row> -->
    </v-container>
</template>

<script>
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseReadOnlyTextField from '@/components/_readonly/BaseReadOnlyTextField'

export default {
    name: "AzSocietiesReadOnly",
    components: {
        BaseReadOnlyTextField,
        BaseIcon,
    },
    data() {
        return {
            alvqa: 'az-societies-list-row-read-only'
        }
    },
    computed: {
        item() {
            return this.$store.getters.getExpandedAzSocieties[0]
        },
        getCity() { return this.$store.getters.getAzSocietiesDetailsCity },
        getCountry() { return this.$store.getters.getAzSocietiesDetailsCountry },
        getNotes() { return this.$store.getters.getAzSocietiesDetailsNotes },
        getAlvId() { return this.$store.getters.getAzSocietiesDetailsAlvId },
        getCurrency() { return this.$store.getters.getAzSocietiesDetailsCurrency },
        getMembershipId() { return this.$store.getters.getAzSocietiesDetailsMembershipId },
        getVisibility() { 
            let visibilities = this.$store.getters['getVisibility' + this.$i18n.locale.toUpperCase()] 
            if(visibilities === undefined) visibilities = this.$store.getters.getVisibilityEN // fallback EN
            if(visibilities === undefined) visibilities = []

            let match = visibilities.find(visibility => {
                    return visibility.value === this.$store.getters.getAzSocietiesDetailsVisibility
                })

            if(match !== undefined) {
                return match.text
            } else {
                return null
            }
        },
    },
    methods: {
        copyToClipboard(item) {
            let address = item.replace(/<br\s*[\/]?>/gi, "\n")
            navigator.clipboard.writeText(address);
        },
    },
    created() {
        this.$store.commit('setCountries')
    },
    mounted() {
        this.$store.commit('setVisibility')
    },
}
</script>